import { idsOf, MigrationSpec } from "../migration.models"
import { MARKETPLACE_ACCOUNT_COLLECTIONS } from "./marketplace_collections"

const aiMarketplaceGuidance: MigrationSpec = {
  type: "MIGRATE_AI_MARKETPLACE_GUIDANCE",
  collection: "AiGuidance",
  risk: "SAFE",
  title: {
    en: "Marketplace guidance → the MARKETPLACE role",
    tr: "Pazaryeri rehberliği → MARKETPLACE rolü"
  },
  description: {
    en:
      "Gives the MARKETPLACE role every guidance whose scope is marketplace work — a marketplace " +
      "account in `channel`, or the QUESTION message type — so the rule keeps applying now that " +
      "marketplace questions are answered by that role. A row scoped ONLY to marketplace work " +
      "moves to it; one that also covers another channel merely gains it.",
    tr:
      "Kapsamı pazaryeri işi olan her rehberliği MARKETPLACE rolüne verir — `channel` içinde bir " +
      "pazaryeri hesabı ya da QUESTION mesaj tipi. Böylece pazaryeri sorularını artık bu rol " +
      "yanıtlarken kural uygulanmaya devam eder. YALNIZCA pazaryerine bağlı satır bu role taşınır; " +
      "başka bir kanalı da kapsayan satır rolü yalnızca ek olarak alır."
  },
  affectedFilter: {
    roles: { $nin: ["MARKETPLACE"] },
    $or: [
      { channel: { $in: idsOf(MARKETPLACE_ACCOUNT_COLLECTIONS) } },
      { messageTypes: "QUESTION" }
    ]
  },
  sampleFields: ["customer", "title", "roles", "channel", "messageTypes"],
  preview: (doc) => {
    const roles = (doc.roles as string[] | undefined) ?? []
    return {
      ...doc,
      // The runner decides move-vs-add from the scope; a row with no roles at all already means
      // every role and is written out as all three, so the probe reads zero once it has run.
      roles: roles.length ? [...roles, "MARKETPLACE"] : ["… + MARKETPLACE"]
    }
  },
  notes: [
    {
      en:
        "Channel ids are compared as strings — that is how AiGuidance.channel stores them. " +
        "`$idsOf` is resolved server-side against the eight marketplace account collections.",
      tr:
        "Kanal kimlikleri string olarak karşılaştırılır — AiGuidance.channel bunları böyle saklar. " +
        "`$idsOf` sunucu tarafında sekiz pazaryeri hesap koleksiyonuna karşı çözülür."
    },
    {
      en:
        "A row with no `roles` already applies to every role; it is rewritten as all three " +
        "explicitly rather than narrowed, so nothing changes about which turns it reaches.",
      tr:
        "`roles` alanı olmayan satır zaten her role uygulanır; daraltılmaz, üç rol açıkça " +
        "yazılır — hangi turlara ulaştığı değişmez."
    }
  ]
}

export default aiMarketplaceGuidance
